<template>
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="mt-4 sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">Purchases</h1>
        <p class="mt-2 text-sm text-gray-700">
          A list of all the purchases
        </p>
      </div>
    </div>
    <div
      class="flex flex-wrap items-center justify-end py-3 mt-2 ml-4 mr-4 space-y-2 bg-white rounded-lg sm:space-y-0 sm:space-x-4"
    >
      <div class="flex items-center px-3 space-x-2">
        <label for="search" class="text-sm font-medium text-gray-700">
          Search
        </label>
        <input
          id="search"
          v-model="filters.search"
          @input="applyFilters"
          type="text"
          placeholder="search by status"
          class="px-3 py-2 border rounded shadow-sm focus:ring focus:ring-blue-200"
        />
      </div>
      <div class="card-header">
        <div class="text-right col-lg-12 col-5">
          <base-button size="sm" type="primary" @click="createPurchase"
            >Add New</base-button
          >
        </div>
      </div>
    </div>

    <div class="px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col mt-4">
        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div
            class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8"
          >
            <div
              class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
            >
              <table class="min-w-full divide-y divide-gray-300">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Date
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Invoice Number
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Supplier
                    </th>

                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody
                  class="relative overflow-visible divide-y divide-gray-200"
                >
                  <tr v-for="item in purchases" :key="item.id">
                    <td
                      class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-0"
                    >
                      {{ item.date }}
                    </td>
                    <td
                      class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap"
                    >
                      {{ item.invoiceNumber }}
                    </td>

                    <td
                      class="px-3 py-4 text-sm text-gray-500 capitalize whitespace-nowrap"
                    >
                      {{ item.supplier }}
                    </td>

                    <td
                      class="px-3 py-4 text-sm text-gray-500 capitalize whitespace-nowrap"
                    >
                      {{ item.status }}
                    </td>

                    <td
                      class="relative px-3 py-4 overflow-visible text-sm text-gray-500 whitespace-nowrap"
                    >
                      <div
                        class="relative inline-block text-left dropdown-container"
                      >
                        <button
                          @click="toggleDropdown(item.purchaseId)"
                          class="flex items-center px-3 py-1 space-x-1 text-white bg-blue-400 rounded-md focus:outline-none"
                        >
                          <span>Actions</span>
                          <svg
                            class="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M19 9l-7 7-7-7"
                            ></path>
                          </svg>
                        </button>

                        <div
                          v-if="dropdownOpen === item.purchaseId"
                          class="absolute right-0 z-50 w-40 mt-2 bg-white border border-gray-200 rounded-md shadow-md"
                        >
                          <button
                            @click="handleAction(item, 'edit')"
                            class="z-50 block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
                          >
                            Edit
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="flex items-center justify-between p-2 px-4 mt-4 bg-white rounded-lg"
            >
              <!-- Records Per Page Selector -->
              <div class="flex items-center space-x-2">
                <label for="per-page" class="text-sm font-medium"
                  >Records per page:</label
                >
                <select
                  id="per-page"
                  v-model="perPage"
                  @change="getPurchases()"
                  class="px-2 py-1 border rounded"
                >
                  <option
                    v-for="option in perPageOptions"
                    :key="option"
                    :value="option"
                  >
                    {{ option }}
                  </option>
                </select>
              </div>
              <Pagination
                :currentPage="pagination.current_page"
                :totalPages="pagination.last_page"
                @page-change="handlePageChange"
              />
              <!-- <div class="card-footer">
                <div
                  v-if="meta"
                  slot="footer"
                  class="flex-wrap col-12 d-flex justify-content-center justify-content-sm-between"
                >
                  <div class>
                    <p class="card-category">
                      Showing {{ meta.from + 1 }} to {{ meta.to }} of
                      {{ meta.total }} entries
                      <span v-if="selectedRows.length"
                        >&nbsp; &nbsp; {{ selectedRows.length }} rows
                        selected</span
                      >
                    </p>
                  </div>
                  <pagination :meta="meta" @paginate="setPagination" />
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "../../components/Pagination.vue";
import { apiHelper } from "../../utils/helpers";
import endpoints from "@/utils/constants";
import { DropdownMenu, DropdownItem, Dropdown } from "element-ui";
import { mapMutations, mapActions } from "vuex";
import pagination from "@/components/AmsaPagination";

export default {
  data() {
    return {
      meta: [],
      purchases: [],
      pagination: {},
      perPage: 10,
      pageSize: 20,
      perPageOptions: [5, 10, 25, 50],
      paginationLinks: [],
      filters: {
        search: ""
      },
      dropdownOpen: null
    };
  },
  components: {
    Pagination,
    pagination
  },
  mounted() {
    this.getPurchases();
    document.addEventListener("click", this.handleClickOutside);
  },

  methods: {
    ...mapActions({
      fetchPurchase: "purchase/fetchPurchase"
    }),

    ...mapMutations({
      resetPurchase: "purchase/resetPurchase",
      setPurchase: "purchase/setPurchase"
    }),
    applyFilters() {
      const { search } = this.filters;
      const page = this.pagination.current_page || 1; // Default to page 1 if undefined
      let url = `/api/v1/purchases?page=${page}&per_page=${this.perPage}`;
      if (search) url += `&search=${encodeURIComponent(search)}`;
      this.getPurchases(url);
    },

    resetFilters() {
      this.filters.search = "";
      this.getPurchases(`/api/v1/purchases?page=1&per_page=${this.perPage}`);
    },

    handlePageChange(page) {
      const { search } = this.filters;
      let url = `/api/v1/purchases?page=${page}&per_page=${this.perPage}`;
      if (search) url += `&search=${encodeURIComponent(search)}`;
      this.getPurchases(url);
    },

    getPurchases(url = `/api/v1/purchases?page=1&per_page=${this.perPage}`) {
      apiHelper
        .call("get", `${endpoints.LARAVEL_BASE_URL}${url}`)
        .then(response => {
          this.purchases = response.data.data;
          this.meta = response.data.meta;
          this.pagination = {
            current_page: response.data.meta.current_page,
            prev: response.data.links.prev,
            next: response.data.links.next,
            last_page: response.data.meta.last_page
          };
          this.generatePaginationLinks();
        });
    },

    generatePaginationLinks() {
      const links = [];
      for (let i = 1; i <= this.pagination.last_page; i++) {
        links.push({
          number: i,
          url: `/api/v1/purchases?page=${i}&per_page=${this.perPage}`,
          active: i === this.pagination.current_page
        });
      }
      this.paginationLinks = links;
    },

    toggleDropdown(purchaseId) {
      if (this.dropdownOpen === purchaseId) {
        this.dropdownOpen = null;
      } else {
        this.dropdownOpen = purchaseId;
      }
    },

    handleClickOutside(event) {
      if (!event.target.closest(".dropdown-container")) {
        this.dropdownOpen = null;
      }
    },

    createPurchase() {
      this.resetPurchase();
      this.$router.push("/purchases/add");
    },

    handleAction(purchase, command) {
      if (command === "edit") {
        this.$router.push(`/purchases/${purchase.purchaseId}/edit`);
      }
    }
  }
};
</script>
